<div class="ng-prices"
     [attr.data-id]="tour.id"
     [attr.data-hotel-id]="tour.hotelId"
     [attr.data-operator]="'1'">
    <div>
        <div class="ng-recalc">
            <span class="ng-tourists">{{ touristLabel }}</span>
        </div>

        <div class="ng-for-tour">
            <app-tour-prices-value [price]="tour.price"
                                   [discount]="tour.discount || 0"></app-tour-prices-value>
        </div>
    </div>
    <div>
        <button type="button"
                class="ng-view-tours showHotelInfo">
            {{ messages.showTours }}
        </button>
    </div>
</div>
